const RETRY_DELAYS_MS = [300, 900];

const wait = (delayMs) =>
  new Promise((resolve) => window.setTimeout(resolve, delayMs));

const getRequestMethod = (input, init) =>
  String(init?.method || (input instanceof Request ? input.method : "GET")).toUpperCase();

const getRequestUrl = (input) =>
  typeof input === "string" || input instanceof URL
    ? String(input)
    : input instanceof Request
    ? input.url
    : "";

/**
 * Retries only idempotent reads to the configured API origin. This covers the
 * short window during an API/proxy restart without ever replaying a write.
 */
export function installApiFetchRetry() {
  if (typeof window === "undefined" || window.__rpoApiFetchRetryInstalled) return;

  const apiBase = String(process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
  if (!apiBase) return;

  const apiOrigin = new URL(apiBase, window.location.origin).origin;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const method = getRequestMethod(input, init);
    const url = getRequestUrl(input);
    const isApiRead =
      (method === "GET" || method === "HEAD") &&
      new URL(url, window.location.origin).origin === apiOrigin;

    if (!isApiRead) return originalFetch(input, init);

    for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt += 1) {
      try {
        return await originalFetch(input, init);
      } catch (error) {
        if (error?.name === "AbortError" || attempt === RETRY_DELAYS_MS.length) {
          throw error;
        }
        await wait(RETRY_DELAYS_MS[attempt]);
      }
    }
  };

  window.__rpoApiFetchRetryInstalled = true;
}
